// Privacy and Terms page rendering
import { getContent } from '../core/store.js';
import { getDomElements } from '../utils/dom.js';

export function renderPrivacyPage() {
    const content = getContent();
    const domRefs = getDomElements();

    if (!domRefs.pageContent || !content) return;

    // Find privacy policy content
    const privacyPolicy = content.find(item => item.name === "privacy_policy");
    if (!privacyPolicy) {
        domRefs.pageContent.innerHTML = `
            <h1>Privacy Policy</h1>
            <p>Privacy policy content not available.</p>
        `;
        return;
    }

    // Get content details
    const title = privacyPolicy.details.find(detail => detail.name === "title")?.value || "Privacy Policy";
    const section = privacyPolicy.details.find(detail => detail.name === "section")?.value || "";

    // Build HTML
    let html = `
        <h1>${title}</h1>
    `;

    html += `
        <section class="legal-section">
            <p>${section}</p>
        </section>
    `;

    domRefs.pageContent.innerHTML = html;
    document.title = "Privacy";
}

export function renderTermsPage() {
    const content = getContent();
    const domRefs = getDomElements();

    if (!domRefs.pageContent || !content) return;

    // Find terms of service content
    const termsOfService = content.find(item => item.name === "terms_of_service");
    if (!termsOfService) {
        domRefs.pageContent.innerHTML = `
            <h1>Terms of Service</h1>
            <p>Terms of service content not available.</p>
        `;
        return;
    }

    // Get content details
    const title = termsOfService.details.find(detail => detail.name === "title")?.value || "Terms of Service";
    const section = termsOfService.details.find(detail => detail.name === "section")?.value || "";

    // Build HTML
    let html = `
        <h1>${title}</h1>
    `;

    html += `
        <section class="legal-section">
            <p>${section}</p>
        </section>
    `;

    domRefs.pageContent.innerHTML = html;
    document.title = "Terms";
}